import gql from 'graphql-tag';

const query = gql`
  query FetchUserMealsQuery {
    dailyTracker {
      userMeals(first: 1000) {
        edges {
          cursor
          node {
            id
            name
            notes
            calories
            proteinGrams
            carbsGrams
            fatGrams
            isUserMeal
            sourceType
            derivedMealsCount
            imageUrl
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
`;

export default query;
